import { initialTableShow } from 'utils/settings';
import moment from 'moment';

export const mainTableConf = [
  {
    isSortable: false,
    field: 'member',
    title: 'Member',
    show: true,
    width: 417,
    valuesExport: ['member']
  },
  {
    isSortable: true,
    field: 'createdAt',
    title: 'Date',
    show: true,
    width: 152,
    valuesExport: ['createdAt']
  },
  {
    isSortable: false,
    field: 'eventName',
    title: 'Activity',
    show: true,
    width: 382,
    valuesExport: ['eventName']
  },
  {
    isSortable: false,
    field: 'network',
    title: 'Network',
    show: true,
    width: 422,
    valuesExport: ['network']
  },
  {
    isSortable: false,
    field: 'addressCountry',
    title: 'Country',
    show: true,
    width: 417,
    valuesExport: ['addressCountry']
  }
];

export const exportConfigPlatformActivities = {
  exportUrl: '/customer/platform/activity/export',
  exportName: 'platformActivities',
  exportFormat: 'zip'
};

export const defaultFilters = {
  plan: [],
  eventName: [],
  datePeriod: {
    startDate: moment().subtract(1, 'week').format('MM/DD/YYYY'),
    endDate: moment().format('MM/DD/YYYY')
  },
  member: '',
  addressCountry: [],
  search: ''
};

export const defaultNavigation = {
  fieldName: 'createdAt',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};
